import { useGetProductsQuery } from '@viome/viome-base/src/usecase/Nutrition/NutritionQuery';

export const useGetHomeProductsViewModel = () => {
  const {
    data: homeProductsData,
    isLoading: ishomeProductsDataLoading,
    isError: ishomeProductsDataError,
  } = useGetProductsQuery({ subscribed_only: true });

  return {
    homeProductsData,
    ishomeProductsDataLoading,
    ishomeProductsDataError,
  };
};
